'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/modal/style/css');

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _css2 = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalForm = _react2.default.createClass({
    displayName: 'ModalForm',
    getInitialState: function getInitialState() {
        return { visible: false };
    },
    showModal: function showModal() {
        this.setState({
            visible: true
        });
    },
    onOk: function onOk() {
        var _this = this;

        var form = this.props.form;
        form.validateFields(function (err, values) {
            if (err) {
                return;
            }
            _this.setState({
                confirmLoading: true
            });
            _this.props.onOk(values);
            _this.setState({
                visible: false,
                confirmLoading: false
            });
        });
    },
    onCancel: function onCancel(e) {

        this.setState({
            visible: false
        });
    },
    render: function render() {
        var _props = this.props,
            title = _props.title,
            width = _props.width,
            _props$btnText = _props.btnText,
            btnText = _props$btnText === undefined ? title : _props$btnText,
            onOk = _props.onOk,
            children = _props.children,
            _props$type = _props.type,
            type = _props$type === undefined ? 'default' : _props$type,
            _props$style = _props.style,
            style = _props$style === undefined ? { display: 'inline-block', marginRight: 10 } : _props$style;

        return _react2.default.createElement(
            'div',
            { style: style },
            _react2.default.createElement(
                _button2.default,
                { onClick: this.showModal, type: type },
                btnText
            ),
            _react2.default.createElement(
                _modal2.default,
                { title: title, visible: this.state.visible,
                    onOk: this.onOk, onCancel: this.onCancel, width: width },
                children
            )
        );
    }
}); /**
     * 点击按钮，弹出相应表单
     */
exports.default = ModalForm;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/modal_form.js
// module id = 1298
// module chunks = 0